import {Component, Input, OnInit} from '@angular/core';
import {Broadcast} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {UtilService} from "../../../services/util.service";
import {Player} from "../../../model/broadcast/player";
import {Game} from "../../../model/broadcast/game";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-box-score',
  templateUrl: './box-score.component.html',
  styleUrls: ['./box-score.component.scss'],
  imports: [
    NgIf,
    NgForOf
  ],
  standalone: true
})
export class BoxScoreComponent implements OnInit {

  @Input() broadcast: Broadcast;
  @Input() game: Game;
  @Input() controlAction: ControlAction;

  constructor(
    public utilService: UtilService,
  ) { }

  ngOnInit(): void {
  }

  public showDueUp(): boolean {
    return !this.isFinished() && this.getDueUp()?.length > 0;
  }

  public isFinished(): boolean {
    if (this.broadcast?.config?.manualStatus) {
      return this.broadcast.manualData?.inningPart === 'F';
    } else {
      return this.game?.finished;
    }
  }

  public getDueUp(): Player[] {
    let lineup: Player[];
    const dueUp: Player[] = [];
    if (!this.game) {
      return dueUp;
    }

    if (this.game.inningPart === 'E') {
      //away comming up
      lineup = this.game.away.lineup.map(spot => spot.players[spot.players.length - 1]);
    } else if (this.game.inningPart === 'M') {
      //home comming up
      lineup = this.game.home.lineup.map(spot => spot.players[spot.players.length - 1]);
    }
    if(lineup) {
      const current = lineup.findIndex(p => (p.guid === this.game.currentBatter.guid));
      dueUp.push(lineup[current]);

      const next = (current + 1) % 9;
      dueUp.push(lineup[next]);

      const afterNext = (next + 1) % 9;
      dueUp.push(lineup[afterNext]);
    }

    return dueUp;
  }

}
